export default __webpack_public_path__ + "8a5f936332e8028c7278a3a25db00925.ttf";